import * as Yup from "yup";

import { LoanApplicationBorrower } from "@eave/shared/types/api";
import { arrayToPattern, PHONE_NUMBER_PATTERN, YYYYMMDD } from "@eave/shared/utils/regex-patterns";
import { MARITAL_STATUS_OPTIONS } from "web_modules/forms/data/maritalStatusOptions";
import { formatPhoneNumber } from "@eave/shared/utils/phone";
import { BorrowerDelta } from "./shared";

export const validationSchema = Yup.object().shape({
  first_name: Yup.string().required(),
  middle_name: Yup.string().nullable(),
  last_name: Yup.string().required(),
  suffix: Yup.string().nullable(),
  relationship_status: Yup.string()
    .matches(arrayToPattern(Object.values(MARITAL_STATUS_OPTIONS)))
    .required(),
  email: Yup.string().email().required(),
  dob: Yup.string().matches(YYYYMMDD, "Please enter a valid Dob date.").required(),
  phone: Yup.string()
    .matches(PHONE_NUMBER_PATTERN, "Please enter a valid phone number.")
    .required(),
  estimated_monthly_income: Yup.number().positive().nullable(),
});

export const initialValuesFromBorrower = (borrower: LoanApplicationBorrower): BorrowerDelta => {
  const {
    first_name,
    last_name,
    middle_name,
    suffix,
    relationship_status,
    email,
    dob,
    phone,
    estimated_monthly_income,
  } = borrower;

  const values: BorrowerDelta = {
    first_name,
    last_name,
    middle_name,
    suffix,
    relationship_status,
    email,
    dob,
    phone: phone ? formatPhoneNumber(phone) : "",
    estimated_monthly_income,
  };

  return values;
};
